import { getCoreDataSecurityDetectedApplicationsByIdSlice } from './get';

export const { requestGetCoreDataSecurityDetectedApplicationsById, resetGetCoreDataSecurityDetectedApplicationsById } =
	getCoreDataSecurityDetectedApplicationsByIdSlice.asyncActionCreators;
